/**
 * Custom settings menu button that targets bunny-settings-menu
 */

import { MediaSettingsMenuButton } from 'media-chrome/menu/media-settings-menu-button.js';
import { getMediaController } from 'media-chrome/utils/element-utils.js';

class BunnySettingsMenuButton extends MediaSettingsMenuButton {
  /**
   * Returns the bunny-settings-menu element
   */
  override get invokeTargetElement(): HTMLElement | null {
    if (this.invokeTarget != null) return super.invokeTargetElement;
    return getMediaController(this)?.querySelector('bunny-settings-menu') ??
      null;
  }
}

if (!globalThis.customElements.get('bunny-settings-menu-button')) {
  globalThis.customElements.define(
    'bunny-settings-menu-button',
    BunnySettingsMenuButton,
  );
}

export default BunnySettingsMenuButton;
